import { gql } from "@/graphql/typed-gql"

/**
 * The bell's whole payload. Title, body, icon and link all come from the server
 * rather than from a `kind` switch here — the wording is the feature, and a copy
 * of it in the browser is a second place for it to drift.
 */
export const NOTIFICATION_FIELDS = gql`
  fragment NotificationFields on Notification {
    id
    kind
    title
    body
    icon
    link
    readAt
    createdAt
  }
`

export const GET_NOTIFICATIONS = gql`
  query Notifications($studentId: ID!) {
    notifications(studentId: $studentId) {
      unreadCount
      items {
        ...NotificationFields
      }
    }
  }
  ${NOTIFICATION_FIELDS}
`
